import { render } from "./slaView.vue?vue&type=template&id=7e27f8f9&scoped=true"
import script from "./slaView.vue?vue&type=script&lang=js"
export * from "./slaView.vue?vue&type=script&lang=js"

import "./slaView.vue?vue&type=style&index=0&id=7e27f8f9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e27f8f9"]])

export default __exports__